import { useTranslation } from 'react-i18next';

export interface ScheduleMeetingProps {

}

const ScheduleMeeting: React.FunctionComponent<ScheduleMeetingProps> = () => {
    const { t } = useTranslation();

    return (
        <>
            <div className="flex flex-col justify-center flex-1">
                <h2 style={{ textAlign: "left" }} className="mb-4">{t('pages.leadCaptureResults.calendar_title')}</h2>
                <p>{t('pages.leadCaptureResults.calendar_desc')}</p>
            </div>
            <div className="max-w-full" style={{ width: "580px" }}>
                <iframe
                    title="hubspot"
                    style={{
                        width: '100%',
                        height: '630px'
                    }}
                    src="https://meetings.hubspot.com/kyle-barrow/symmio-sales-discovery?embed=true"
                />
            </div>
        </>
    );
};

export default ScheduleMeeting;